import * as datastore from '@/datastore'

export interface Household_User extends datastore.Reference {
	displayName: string
	householdId: string
	isAdmin: boolean
	photoURL: string
	userId: string
}

export const defaultHousehold_User: Readonly<Household_User> = {
	$id: '',
	displayName: '',
	householdId: '',
	isAdmin: false,
	photoURL: '',
	userId: '',
}
